// extracted by css-extract-rspack-plugin
export default {"navbarHideable":"navbarHideable_jvwV","navbarHidden":"navbarHidden_nLSi"};